import { render } from "./StarRatingDisplay.vue?vue&type=template&id=588fbb48&scoped=true"
import script from "./StarRatingDisplay.vue?vue&type=script&lang=js"
export * from "./StarRatingDisplay.vue?vue&type=script&lang=js"

import "./StarRatingDisplay.vue?vue&type=style&index=0&id=588fbb48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-588fbb48"]])

export default __exports__